import { useRef, useState } from "preact/hooks"
import { Upload } from "lucide-react"
import { Button } from "../../../../../components/ui/button"
import { uploadPromotionEffectiveness } from "../../../../../api/promotion_effectiveness"
import { toast } from "../../../../../components/ui/use-toast"

interface PromotionPerformanceUploadProps {
  promotion_id: string
  onImported: () => void
}

export function PromotionPerformanceUpload({ promotion_id, onImported }: PromotionPerformanceUploadProps) {
  const input_ref = useRef<HTMLInputElement>(null)
  const [uploading, set_uploading] = useState(false)

  async function handle_files(files: FileList | null) {
    if (!files || files.length === 0) return
    set_uploading(true)
    try {
      const result = await uploadPromotionEffectiveness(promotion_id, Array.from(files))
      toast({
        title: "Performance data imported",
        description: `${result.imported_rows} row${result.imported_rows === 1 ? "" : "s"} imported${result.skipped_rows.length ? `, ${result.skipped_rows.length} skipped` : ""}.`,
      })
      onImported()
    } catch (error) {
      toast({
        title: "Import failed",
        description: error instanceof Error ? error.message : "Could not import performance data.",
        variant: "destructive",
      })
    } finally {
      set_uploading(false)
      if (input_ref.current) input_ref.current.value = ""
    }
  }

  return (
    <div class="flex flex-wrap items-center gap-2">
      <input
        ref={input_ref}
        type="file"
        accept=".csv,.xlsx"
        multiple
        class="hidden"
        onChange={(event: Event) => handle_files((event.target as HTMLInputElement).files)}
      />
      <Button onClick={() => input_ref.current?.click()} disabled={uploading} variant="outline">
        <Upload className="h-4 w-4 mr-2" />
        {uploading ? "Uploading..." : "Upload metrics"}
      </Button>
      <a
        href="/api/promotions/effectiveness-template"
        class="text-sm text-blue-700 hover:text-blue-900"
      >
        Download template
      </a>
    </div>
  )
}
